<!--  -->
<template>
    <div>
        <div id="head" class="headdq" v-if="this.$route.name == 'NationalActivity'">
        </div>
        <div id="head" class="headdq" v-if="this.$route.name == 'Region' || this.$route.name == 'NationWide'">
            <div class="logo">
                <img class="leftImg" src="../assets/xlogo/logo.png" alt="">
                <!-- <img class="rightImg" src="../assets/xlogo/fx.png" alt=""> -->
            </div>
        </div>
        <div id="head" class="headqg" v-if="this.$route.name == 'Details' ">
            <div class="logo">
                <img class="leftImg" src="../assets/xlogo/logo.png" alt="">
                <!-- <img class="rightImg" src="../assets/xlogo/fx.png" alt=""> -->
            </div>
        </div>
        <div id="head" class="headyh" v-if="this.$route.name == 'Bank' ">
            <div class="logo">
                <img class="leftImg" src="../assets/xlogo/logo.png" alt="">
                <!-- <img class="rightImg" src="../assets/xlogo/fx.png" alt=""> -->
            </div>
        </div>

        <div id="heads" class="headkk" v-if="this.$route.name == 'Blank'">
            <div class="logo">
                <img class="leftImg" src="../assets/kk/logo.png" alt="">
                <!-- <img class="rightImg" src="../assets/box/fx.png" alt=""> -->
            </div>
        </div>
        <div id="headt" class="headhaojuan" v-if="this.$route.name == 'GoodRoll'">

        </div>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from 'vue';
import { Popup } from 'vant';
Vue.use(Popup);
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   console.log(this.$route);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    #head{
        height: 1100px;
        width: 100%;
        background-size:100% 100%;   
        position: relative;
            .logo{
                padding-top: 42px;
                display: flex;
                justify-content: space-between;
                .leftImg{
                    width: 215px;
                    height: 80px;
                    padding-left: 40px;
                }
                .rightImg{
                    width: 115px;
                    height: 49px;
                }
            }
    }
    #heads{
        height: 300px;
        width: 100%;
        background-size:100% 100%;   
        position: relative;
            .logo{
                padding-top: 42px;
                display: flex;
                justify-content: space-between;
                .leftImg{
                    width: 156px;
                    height: 55px;
                    padding-left: 40px;
                }
                .rightImg{
                    width: 115px;
                    height: 49px;
                }
            }
    }
    #headt{
        height: 983px;
        width: 900px;
        background-size:100% 100%;   
        position: relative;
        }

    .headdq{
        background: url("../assets/xlogo/Banner.png")no-repeat;
    }
    .headqg{
        background: url("../assets/xlogo/Banner.png")no-repeat;
    }
    .headkk{
        background: url("../assets/kk/kbbjpng.png")no-repeat;
    }
    .headhaojuan{
        background: url("../assets/kk/haojuanpng.png")no-repeat;
    }
    .headyh{
        background: url("../assets/xlogo/Banner.png")no-repeat;
    }

</style>